class WeChatOrganizationTypeDict {
    static ENTERPRISE_BUSINESS = 2;
    static ENTERPRISE_BUSINESS_DESC = '企业商户';
    static PUBLIC_FOUNDATION = 3;
    static SELF_EMPLOYMENT_MERCHANT = 4;
    static SELF_EMPLOYMENT_MERCHANT_DESC = '个体商户';
    static SOCIAL_GROUP = 1708;
    static MICRO_SUB_MERCHANT = 2401;
    static MICRO_SUB_MERCHANT_DESC = '小微商户';
    static PERSONAL_SELLER = 2500;
    static GOVERNMENT_GROUP = 2502;
    static ORGANIZATION_TYPES = {};
    static SUB_MCH_AMOUNT_LIMIT_DESC = {};
}

WeChatOrganizationTypeDict.ORGANIZATION_TYPES[WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS] = WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS_DESC;
WeChatOrganizationTypeDict.ORGANIZATION_TYPES[WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT] = WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT_DESC;
WeChatOrganizationTypeDict.ORGANIZATION_TYPES[WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT] = WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT_DESC;

WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT] =  '正常日收款额度为10万，若交易良好则自动提升至20-30万/日，若交易异常则自动下降至5万以下/日；信用卡单日收款不超过1千，信用卡单月收款不超过1万。';
WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT] ='正常日收款额度为200万，若交易良好则自动提升额度，若交易异常则下降额度；无信用卡收款额度限制。';
WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS] = '不受限制';

class ContactorTypeDict  {
    static CORPORATION = 65;
    static CORPORATION_DESC = '经营者/法人';
    static TRUSTIER = 66;
    static TRUSTIER_DESC = '经办人';
    static CONTACTOR_TYPES = {};
};
ContactorTypeDict.CONTACTOR_TYPES[ContactorTypeDict.CORPORATION] = ContactorTypeDict.CORPORATION_DESC;
ContactorTypeDict.CONTACTOR_TYPES[ContactorTypeDict.TRUSTIER] = ContactorTypeDict.TRUSTIER_DESC;
export {WeChatOrganizationTypeDict, ContactorTypeDict}